<div class="Footer_bottom">
  <section>
    <div class="container-fluid">
      <div class="d-md-flex justify-content-between my-3">
        <div class="tabs-list rounded-pill mb-3 overflow-auto">
          <mat-button-toggle-group name="approvalTabs" aria-label="Approval request type">
            <ng-container *ngFor="let tab of approvalTabs">
              <mat-button-toggle value="{{ tab.key }}" [checked]="tab?.isChecked" (click)="tabChanges(tab)" *ngIf="tab?.isActive">
                <span class="d-flex align-items-center">
                  {{ tab.label }}
                  <span class="badge rounded-pill ms-2" *ngIf="tab.key === 'interest' && interestTotalCount > 0" style="background-color: #00625F;">{{ interestTotalCount }}</span>
                  <span class="badge rounded-pill ms-2" *ngIf="tab.key === 'employeeChange' && employeeChangePendingCount > 0" style="background-color: #00625F;">{{ employeeChangePendingCount }}</span>
                </span>
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </div>
      </div>

      <section *ngIf="selectedTab?.key === 'interest'">
        <div class="card border-0 mb-3 mt-3">
            <div class="card-body">
              <div class="d-sm-flex mb-3 justify-content-between align-items-center">
                <mat-paginator
                  [length]="interestTotalCount"
                  [pageSize]="interestLimit"
                  [pageSizeOptions]="[5, 10, 25, 50]"
                  (page)="pageHandlerInterest($event)"
                  showFirstLastButtons
                  *ngIf="interestTotalCount > 0 && interestList?.length">
                </mat-paginator>
                <button class="btn d-flex align-items-center text-white filterBtn rounded-pill" mat-button [matMenuTriggerFor]="interestFilterMenu">
                  <img src="/assets/dashboardMedia/filter.svg" class="filterIcon" alt=""> Filter
                </button>
              </div>
              <mat-menu #interestFilterMenu="matMenu" class="check reportFilter">
                <div class="card-body">
                  <div class="container" (click)="$event.stopPropagation()">
                    <form [formGroup]="interestFilterForm">
                      <div class="row">
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Country</mat-label>
                            <mat-select formControlName="countryId" (selectionChange)="onInterestCountryChange($event)">
                              <mat-select-trigger *ngIf="interestFilterForm?.value?.countryId">
                                <img [src]="interestFilterForm.value?.countryId?.country_icons" alt="" class="option-image" *ngIf="interestFilterForm.value?.countryId?.country_icons">
                                <span>{{ interestFilterForm.value?.countryId?.name }}</span>
                              </mat-select-trigger>
                              <mat-option *ngFor="let c of countrys" [value]="c">
                                <img [src]="c?.country_icons" alt="" class="option-image" *ngIf="c?.country_icons">
                                {{ c?.name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Industry/Sector</mat-label>
                            <mat-select formControlName="sectorId">
                              <mat-option *ngFor="let s of sectorNames" [value]="s">{{ s?.name }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Company Name</mat-label>
                            <input matInput formControlName="company_name" placeholder="Search by company name">
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="status">
                              <mat-option value="">All</mat-option>
                              <mat-option value="pending">Pending</mat-option>
                              <mat-option value="approved">Approved</mat-option>
                              <mat-option value="declined">Declined</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="text-end w-100">
                          <button type="button" class="btn btn-reset rounded-pill me-2" (click)="resetInterestFilter()">Reset</button>
                          <button type="button" class="btn btn-search rounded-pill text-white" (click)="applyInterestFilter()">Search</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </mat-menu>
              <div style="overflow-x: auto;">
                <table class="table" style="min-width: 900px;">
                  <thead class="bg-light">
                    <tr>
                      <th class="fw-600">S.No</th>
                      <th class="fw-600">Country</th>
                      <th class="fw-600">Industry/Sector</th>
                      <th class="fw-600">Company Name</th>
                      <th class="fw-600">Date</th>
                      <th class="fw-600">Status</th>
                      <th class="fw-600">Decline Reason</th>
                      <th class="fw-600">Action</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let row of interestList; let i = index">
                      <td>{{ interestSkip + i + 1 }}</td>
                      <td>{{ row.country?.name || row['country.name'] || '---' }}</td>
                      <td>{{ row.sector?.name || row['sector.name'] || '---' }}</td>
                      <td>{{ row.company_name || '---' }}</td>
                      <td>{{ formatDisplayDate(row.createdAt) }}</td>
                      <td>
                        <span class="status-badge" [ngClass]="{
                          'status-pending': row.status === 'pending',
                          'status-approved': row.status === 'approved',
                          'status-declined': row.status === 'declined'
                        }">{{ (row.status | titlecase) || '---' }}</span>
                      </td>
                      <td>{{ row.decline_reason || '---' }}</td>
                      <td>
                        <ng-container *ngIf="row.status === 'pending'">
                          <button mat-icon-button matTooltip="Approve" (click)="approveInterest(row)" class="me-1">
                            <img src="../../../../assets/images/tick-blue.svg" alt="Approve" class="img-fluid" style="width: 24px;">
                          </button>
                          <button mat-icon-button matTooltip="Reject" (click)="rejectInterest(row)" class="me-1">
                            <img src="../../../../assets/images/close-color.svg" alt="Reject" class="img-fluid" style="width: 24px;">
                          </button>
                        </ng-container>
                        <span *ngIf="row.status !== 'pending'">—</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center align-items-center p-5" *ngIf="!interestList?.length">
                <img alt="no data" src="../../../../assets/no_data_image/error-logo.png" class="noDataImage">
              </div>
            </div>
          </div>
        </section>

      <section *ngIf="selectedTab?.key === 'employeeChange'">
        <div class="card border-0 mb-3 mt-3">
            <div class="card-body">
              <div class="d-sm-flex mb-3 justify-content-between align-items-center">
                <mat-paginator
                  [length]="employeeChangeTotalCount"
                  [pageSize]="employeeChangeLimit"
                  [pageSizeOptions]="[5, 10, 25, 50]"
                  (page)="pageHandlerEmployeeChange($event)"
                  showFirstLastButtons
                  *ngIf="employeeChangeTotalCount > 0 && employeeChangeList?.length">
                </mat-paginator>
                <button class="btn d-flex align-items-center text-white filterBtn rounded-pill" mat-button [matMenuTriggerFor]="employeeChangeFilterMenu">
                  <img src="/assets/dashboardMedia/filter.svg" class="filterIcon" alt=""> Filter
                </button>
              </div>
              <mat-menu #employeeChangeFilterMenu="matMenu" class="check reportFilter">
                <div class="card-body">
                  <div class="container" (click)="$event.stopPropagation()">
                    <form [formGroup]="employeeChangeFilterForm">
                      <div class="row">
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Requested By</mat-label>
                            <mat-select formControlName="user_id">
                              <mat-option value="">All</mat-option>
                              <mat-option *ngFor="let u of employeeChangeUsers" [value]="u?.id">{{ u?.name || u?.email || '—' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Company</mat-label>
                            <mat-select formControlName="msme_id">
                              <mat-option value="">All</mat-option>
                              <mat-option *ngFor="let m of employeeChangeMsmes" [value]="m?.id">{{ m?.name || '—' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Current Type</mat-label>
                            <mat-select formControlName="msme_classification_id">
                              <mat-option value="">All</mat-option>
                              <mat-option *ngFor="let c of msmeClassifications" [value]="c">{{ c?.type || '—' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4">
                          <mat-form-field appearance="outline" class="w-100 p-0 mb-3">
                            <mat-label>Requested Type</mat-label>
                            <mat-select formControlName="requested_msme_classification_id">
                              <mat-option value="">All</mat-option>
                              <mat-option *ngFor="let c of msmeClassifications" [value]="c">{{ c?.type || '—' }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="text-end w-100">
                          <button type="button" class="btn btn-reset rounded-pill me-2" (click)="resetEmployeeChangeFilter()">Reset</button>
                          <button type="button" class="btn btn-search rounded-pill text-white" (click)="applyEmployeeChangeFilter()">Search</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </mat-menu>
              <div style="overflow-x: auto;">
                <table class="table" style="min-width: 1000px;">
                  <thead class="bg-light">
                    <tr>
                      <th class="fw-600">S.No</th>
                      <th class="fw-600">Requested By</th>
                      <th class="fw-600">Company</th>
                      <th class="fw-600">Current Employees</th>
                      <th class="fw-600">Requested Employees</th>
                      <th class="fw-600">Type Change</th>
                      <th class="fw-600">Date</th>
                      <th class="fw-600">Status</th>
                      <th class="fw-600">Action</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let row of employeeChangeList; let i = index">
                      <td>{{ employeeChangeSkip + i + 1 }}</td>
                      <td>{{ row.name }}</td>
                      <td>{{ row.msme?.name || row['msme.name'] || '---' }}</td>
                      <td>{{ row.employeeCount != null ? row.employeeCount : '---' }}</td>
                      <td><u>{{ row.requestedEmployeeCount != null ? row.requestedEmployeeCount : '---' }}</u></td>
                      <td class="text-primary">{{ getTypeChangeLabel(row) }}</td>
                      <td>{{ formatDisplayDate(row.updatedAt || row.createdAt) }}</td>
                      <td>
                        <span class="status-badge" [ngClass]="{
                          'status-pending': row.msme_classification_status === 1,
                          'status-approved': row.msme_classification_status === 2,
                          'status-declined': row.msme_classification_status === 3
                        }">{{ getEmployeeChangeStatusLabel(row) }}</span>
                      </td>
                      <td>
                        <ng-container *ngIf="row.msme_classification_status === 1">
                          <button mat-icon-button matTooltip="Approve" (click)="approveMsmeType(row)" class="me-1">
                            <img src="../../../../assets/images/tick-blue.svg" alt="Approve" class="img-fluid" style="width: 24px;">
                          </button>
                          <button mat-icon-button matTooltip="Reject" (click)="rejectMsmeType(row)" class="me-1">
                            <img src="../../../../assets/images/close-color.svg" alt="Reject" class="img-fluid" style="width: 24px;">
                          </button>
                        </ng-container>
                        <span *ngIf="row.msme_classification_status !== 1">—</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center align-items-center p-5" *ngIf="!employeeChangeList?.length">
                <img alt="no data" src="../../../../assets/no_data_image/error-logo.png" class="noDataImage">
              </div>
            </div>
          </div>
        </section>
    </div>
  </section>
</div>
